import React from "react";
import PropTypes from "prop-types";

import Dashboard231 from "../../../Img/DM/dashboard/231.PNG";
import Dashboard404 from "../../../Img/DM/dashboard/404.PNG";
import Dashboard426 from "../../../Img/DM/dashboard/426.PNG";
import Dashboard454 from "../../../Img/DM/dashboard/454.PNG";
import Dashboard508 from "../../../Img/DM/dashboard/508.PNG";
import Dashboard516 from "../../../Img/DM/dashboard/516.PNG";
import Dashboard710 from "../../../Img/DM/dashboard/710.PNG";
// import Dashboard711 from "../../../Img/DM/dashboard/711.PNG";
// import Dashboard712 from "../../../Img/DM/dashboard/712.PNG";
// import Dashboard713 from "../../../Img/DM/dashboard/713.PNG";
import Dashboard716 from "../../../Img/DM/dashboard/716.PNG";
import Dashboard748 from "../../../Img/DM/dashboard/748.PNG";
import Dashboard800 from "../../../Img/DM/dashboard/800.PNG";
import Dashboard834 from "../../../Img/DM/dashboard/834.PNG";
import Dashboard894 from "../../../Img/DM/dashboard/894.PNG";
import Dashboard646 from "../../../Img/DM/dashboard/646.PNG";
import Dashboard072 from "../../../Img/DM/dashboard/072.PNG";

import * as DMConst from "../NonComponents/DMConst";

class DMDashboardForm extends React.Component {
    static propTypes = {
        selectedCountryMstID: PropTypes.number,
    };

    static defaultProps = {
        selectedCountryMstID: 0,
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const selectedCountryMstID = props.selectedCountryMstID;

            let dashboardCountryImage;

            switch (selectedCountryMstID) {
                case DMConst.countryCodeEthiopia:
                    dashboardCountryImage = Dashboard231;
                    break;

                case DMConst.countryCodeKenya:
                    dashboardCountryImage = Dashboard404;
                    break;

                case DMConst.countryCodeLesotho:
                    dashboardCountryImage = Dashboard426;
                    break;

                case DMConst.countryCodeMalawi:
                    dashboardCountryImage = Dashboard454;
                    break;

                case DMConst.countryCodeMozambique:
                    dashboardCountryImage = Dashboard508;
                    break;

                case DMConst.countryCodeNamibia:
                    dashboardCountryImage = Dashboard516;
                    break;

                case DMConst.countryCodeSouthAfrica1:
                    dashboardCountryImage = Dashboard710;
                    break;

                case DMConst.countryCodeSouthAfrica2:
                    dashboardCountryImage = Dashboard710;
                    break;

                case DMConst.countryCodeSouthAfrica3:
                    dashboardCountryImage = Dashboard710;
                    break;

                case DMConst.countryCodeSouthAfrica4:
                    dashboardCountryImage = Dashboard710;
                    break;

                case DMConst.countryCodeeSwatini:
                    dashboardCountryImage = Dashboard748;
                    break;

                case DMConst.countryCodeTanzania:
                    dashboardCountryImage = Dashboard834;
                    break;

                case DMConst.countryCodeUganda:
                    dashboardCountryImage = Dashboard800;
                    break;

                case DMConst.countryCodeZimbabwe1:
                    dashboardCountryImage = Dashboard716;
                    break;

                case DMConst.countryCodeZambia:
                    dashboardCountryImage = Dashboard894;
                    break;

                case DMConst.countryCodeRwanda:
                    dashboardCountryImage = Dashboard646;
                    break;

                case DMConst.countryCodeBotswana:
                    dashboardCountryImage = Dashboard072;
                    break;

                default:
                    dashboardCountryImage = null;
                    break;
            }

            /* maxWidth ensures images will not expand past the size of appContent, causing a
               horizontal scrollbar to appear. */
            const dashboardImg = (
                <img
                    alt="" // to avoid hint
                    src={dashboardCountryImage}
                    style={{
                        maxWidth: "100%",
                    }}
                />
            );

            return <div>{dashboardImg}</div>;
        } catch (exception) {
            return (
                <div
                    className={"DMDashboardFormDiv"}
                    key={"DMDashboardFormDiv"}
                >
                    <h3 key={"DMDashboardFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMDashboardForm;
